/* eslint-disable indent */
import * as actions from "../actions/actionTypes";

export const round = (num) => Math.round(num * 100) / 100;

export const statsColorPalette = [
  /*[162, 237, 103],
  [52, 200, 135],
  [0, 158, 146],
  [0, 114, 130],
  [42, 72, 88],*/
  [131, 235, 41],
  [0, 195, 132],
  [0, 146, 175],
  [0, 92, 160],
  [7, 39, 96],
];

export const statsBooleanColorPalette = [
  [131, 235, 41],
  [7, 39, 96],
];

export const storeAttributes = {
  "Consumer Demographics": [
    "Gender",
    "Gen Z or Younger",
    "Millenials",
    "Gen X",
    "Baby Boomers",
    "Elders",
    "High Income",
    "Medium Income",
    "Low Income",
    "Local Consumer",
    "Tourist Consumer",
    "Monthly Visitor",
  ],
  "Consumer Interest": [
    "Fitness",
    "Lifestyle",
    "Fashion",
    "Holiday Shopping",
    "Customer Visiting Competitors",
  ],
  "Store Surrounding": ["Essential Service", "Universities", "Airport"],
  Footfall: [
    "Footfall Monday",
    "Footfall Tuesday",
    "Footfall Wednesday",
    "Footfall Thursday",
    "Footfall Friday",
    "Footfall Saturday",
    "Footfall Sunday",
  ],
};

export const dailyPatternsAttributes = [
  "Gender",
  "Age group",
  "Income group",
  "Consumer group",
];

export const percentageAttributes = [
  "Gender",
  "Gen Z or Younger",
  "Millenials",
  "Gen X",
  "Baby Boomers",
  "Elders",
  "High Income",
  "Medium Income",
  "Low Income",
  "Local Consumer",
  "Tourist Consumer",
  "Fitness",
  "Lifestyle",
  "Fashion",
  "Holiday Shopping",
  "Customer Visiting Competitors",
];

const booleanAttributes = ["Essential Service", "Universities", "Airport"];

const quantityAttributes = [
  "Monthly Visitor",
  "Footfall Monday",
  "Footfall Tuesday",
  "Footfall Wednesday",
  "Footfall Thursday",
  "Footfall Friday",
  "Footfall Saturday",
  "Footfall Sunday",
];

let storeStats = {};
let districtStats = {};

for (let [key, value] of Object.entries(storeAttributes)) {
  for (let attribute of value) {
    if (percentageAttributes.includes(attribute)) {
      storeStats[attribute] = {
        type: "percentage",
        max: -Infinity,
        min: Infinity,
        ranges: [
          { label: "", value: 0 },
          { label: "", value: 0 },
          { label: "", value: 0 },
          { label: "", value: 0 },
          { label: "", value: 0 },
        ],
      };
      districtStats[attribute] = {
        type: "percentage",
        max: -Infinity,
        min: Infinity,
        ranges: [
          { label: "", value: 0 },
          { label: "", value: 0 },
          { label: "", value: 0 },
          { label: "", value: 0 },
          { label: "", value: 0 },
        ],
      };
    } else if (quantityAttributes.includes(attribute)) {
      storeStats[attribute] = {
        type: "quantity",
        max: -Infinity,
        min: Infinity,
        ranges: [
          { label: "", value: 0 },
          { label: "", value: 0 },
          { label: "", value: 0 },
          { label: "", value: 0 },
          { label: "", value: 0 },
        ],
      };
      districtStats[attribute] = {
        type: "quantity",
        max: -Infinity,
        min: Infinity,
        ranges: [
          { label: "", value: 0 },
          { label: "", value: 0 },
          { label: "", value: 0 },
          { label: "", value: 0 },
          { label: "", value: 0 },
        ],
      };
    } else if (booleanAttributes.includes(attribute)) {
      storeStats[attribute] = {
        type: "boolean",
        ranges: [0, 0],
      };
      districtStats[attribute] = {
        type: "boolean",
        ranges: [0, 0],
      };
    }
  }
}

const dataReducer = (state = {}, action) => {
  switch (action.type) {
    /*case actions.FETCH_DATA:
      return {
        ...state,
      };*/

    case actions.FETCH_GEO_DISTRICTS:
      return {
        ...state,
        geoDistricts: action.geoDistricts,
      };

    case actions.FETCH_DATA_DISTRICTS:
      for (let district of action.data) {
        for (let [attribute, value] of Object.entries(district.data)) {
          if (districtStats[attribute].type === "boolean") {
            districtStats[attribute].ranges[value]++;
          } else {
            if (value < districtStats[attribute].min)
              districtStats[attribute].min = value;
            if (value > districtStats[attribute].max)
              districtStats[attribute].max = value;
          }
        }
      }

      for (let [attribute, value] of Object.entries(districtStats)) {
        if (value.type === "percentage") {
          value.min = Math.floor(value.min * 100);
          value.max = Math.floor(value.max * 100 + 1);
        }
      }

      for (let district of action.data) {
        for (let [attribute, value] of Object.entries(district.data)) {
          if (districtStats[attribute].type === "percentage") {
            const { min, max } = districtStats[attribute];
            const step = (max - min) / 5;
            const index = Math.floor((value * 100 - min) / step);
            districtStats[attribute].ranges[index].value++;
            districtStats[attribute].ranges[0].label =
              "<" + round(min + step) + "%";
            districtStats[attribute].ranges[1].label =
              round(min + step) + "-" + round(min + step * 2) + "%";
            districtStats[attribute].ranges[2].label =
              round(min + step * 2) + "-" + round(min + step * 3) + "%";
            districtStats[attribute].ranges[3].label =
              round(min + step * 3) + "-" + round(min + step * 4) + "%";
            districtStats[attribute].ranges[4].label =
              ">" + round(min + step * 4) + "%";
          } else if (districtStats[attribute].type === "quantity") {
            if (attribute === "Monthly Visitor") {
              const index = Math.floor(value / 3400);
              districtStats[attribute].ranges[index].value++;
              districtStats[attribute].ranges[0].label = "<3.4k";
              districtStats[attribute].ranges[1].label = "3.4-6.8k";
              districtStats[attribute].ranges[2].label = "6.8-10.2k";
              districtStats[attribute].ranges[3].label = "10.2-13.6k";
              districtStats[attribute].ranges[4].label = ">13.6k";
            } else {
              const index = Math.floor(value / 340);
              districtStats[attribute].ranges[index].value++;
              districtStats[attribute].ranges[0].label = "<340";
              districtStats[attribute].ranges[1].label = "340-680";
              districtStats[attribute].ranges[2].label = "680-1020";
              districtStats[attribute].ranges[3].label = "1020-1360";
              districtStats[attribute].ranges[4].label = ">1360";
            }
          }
        }
      }

      return {
        ...state,
        districts: action.data,
        districtStats,
      };

    case actions.FETCH_DATA_STORES:
      for (let store of action.data) {
        for (let [attribute, value] of Object.entries(store.data)) {
          if (storeStats[attribute].type === "boolean") {
            storeStats[attribute].ranges[value]++;
          } else {
            if (value < storeStats[attribute].min)
              storeStats[attribute].min = value;
            if (value > storeStats[attribute].max)
              storeStats[attribute].max = value;
          }
        }
      }

      for (let [attribute, value] of Object.entries(storeStats)) {
        if (value.type === "percentage") {
          value.min = Math.floor(value.min * 100);
          value.max = Math.floor(value.max * 100 + 1);
        }
      }

      for (let store of action.data) {
        for (let [attribute, value] of Object.entries(store.data)) {
          if (storeStats[attribute].type === "percentage") {
            const { min, max } = storeStats[attribute];
            const step = (max - min) / 5;
            const index = Math.floor((value * 100 - min) / step);
            storeStats[attribute].ranges[index].value++;
            storeStats[attribute].ranges[0].label =
              "<" + round(min + step) + "%";
            storeStats[attribute].ranges[1].label =
              round(min + step) + "-" + round(min + step * 2) + "%";
            storeStats[attribute].ranges[2].label =
              round(min + step * 2) + "-" + round(min + step * 3) + "%";
            storeStats[attribute].ranges[3].label =
              round(min + step * 3) + "-" + round(min + step * 4) + "%";
            storeStats[attribute].ranges[4].label =
              ">" + round(min + step * 4) + "%";
          } else if (storeStats[attribute].type === "quantity") {
            if (attribute === "Monthly Visitor") {
              const index = Math.floor(value / 1500);
              storeStats[attribute].ranges[index].value++;
              storeStats[attribute].ranges[0].label = "<1.5k";
              storeStats[attribute].ranges[1].label = "1.5-3k";
              storeStats[attribute].ranges[2].label = "3-4.5k";
              storeStats[attribute].ranges[3].label = "4.5-6k";
              storeStats[attribute].ranges[4].label = ">6k";
            } else {
              const index = Math.floor(value / 150);
              storeStats[attribute].ranges[index].value++;
              storeStats[attribute].ranges[0].label = "<150";
              storeStats[attribute].ranges[1].label = "150-300";
              storeStats[attribute].ranges[2].label = "300-450";
              storeStats[attribute].ranges[3].label = "450-600";
              storeStats[attribute].ranges[4].label = ">600";
            }
          }
        }
      }

      return {
        ...state,
        stores: action.data,
        storeStats,
      };

    case actions.FETCH_DATA_COUNTRY:
      return {
        ...state,
        country: action.country,
      };

    /*case actions.FETCH_DATA_CONSUMER_VIEWER:
      return {
        ...state,
        consumerViewer: action.consumerViewer,
      };*/

    case actions.SELECT_ATTRIBUTE:
      return {
        ...state,
        selectedAttribute: action.selectedAttribute,
      };

    case actions.SELECT_ANALYZE_TYPE:
      return {
        ...state,
        selectedAnalyzeType: action.payload,
        selectedAttribute: "",
      };

    default:
      return state;
  }
};

export default dataReducer;
